import EditorRelatedConditionsHeading from './EditorRelatedConditionsHeading';
import EditorConditionActionsContainer from './EditorConditionActionsContainer';
import { useEditorActions } from '../../hooks/useEditorActions';
import ConditionBox from '../common/ConditionBox';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorFilterGroupHeadCondition = props => {
  const {
    conditionPath,
    logicGroup,
    inputUse
  } = props;
  const {
    onConditionDelete
  } = useEditorActions();
  return /*#__PURE__*/_jsx(EditorConditionActionsContainer, {
    conditionPath: conditionPath,
    isFilterBranch: true,
    onConditionDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(ConditionBox, {
      isNestedOrHeader: true,
      children: /*#__PURE__*/_jsx(EditorRelatedConditionsHeading, {
        conditionPath: conditionPath
        // dataSeleniumInfo
        ,
        inputUse: inputUse,
        logicGroup: logicGroup
      })
    })
  });
};
export default EditorFilterGroupHeadCondition;